import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {

  @Input() videoUrl: string = '';
  @Input() index: number = 0;
  @Input() placeholder: string = '';
  @Input() openModal: boolean = false;
  @Input() isMetadataVisible: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
